
import React, { useRef } from 'react';
import DataVisualization from './hero/DataVisualization';
import BackgroundEffects from './hero/BackgroundEffects';
import HeroContent from './hero/HeroContent';

/**
 * Hero section component for the landing page
 * Combines optimized 3D visualization, background effects, and main content
 */
const HeroSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  
  return (
    <section ref={sectionRef} className="relative overflow-hidden py-28 md:py-36">
      {/* Background elements and effects */}
      <BackgroundEffects />
      
      {/* Optimized 3D data visualization */}
      <DataVisualization />
      
      {/* Main content area */}
      <HeroContent />
    </section>
  );
};

export default HeroSection;
